/*
 * @Author: caiqin.xie
 * @since: 2023-08-03 17:03:29
 * @lastTime: 2023-08-24 17:56:26
 * @LastEditors: huangfuchunmei
 * @message: 维修流程
 * @url: www.picoxr.com/cn/support/repair-process
 */
import React from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Process from "./components/ProcessList";
import { useDevice }  from '@/hooks'
import request from '@/common/request'
import { DOMAIN_API, REPAIRPROCESSPOS, COUNTRY_HREFLANG, COUNTRY_LIST } from '@/common/const'
import styles from "./index.module.scss";
import LazyMedia from "@/components/LazyMedia"
import { IBanner } from "@/common/types";

const RepairProcess = (props: any) => {
  const {ctry, words, data} = props.data
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  const banner: IBanner = data.data.length ? data.data[0] : null

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/repair-process`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{words?.support_repair_process_seo_title}</title>
        <meta name="description" content={words?.support_repair_process_seo_description} />
        <meta name="keywords" content={words?.support_repair_process_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/repair-process`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['repair-process-wrap']}>
        {/* banner区 */}
        <div className={styles['banner-wrap']}>
          {banner[newDevice].extension === '.mp4'
            ? <LazyMedia type="video" className={styles['banner-img']} LazyClassName="full-wh" loop autoPlay preload="auto" playsInline muted src={banner[newDevice]?.url}></LazyMedia>
            : <LazyMedia type="image" className={styles['banner-img']} LazyClassName="full-wh" src={banner[newDevice]?.url} alt={banner[newDevice]?.alt} />
          }
          <h1 className={styles['banner-title']}>{words?.support_repair_process_banner_title}</h1>
          {/* Repair process */}
        </div>
        {/* 内容区 */}
        <div className={styles['repair-content-wrap']}>

          <Process ctry={ctry} words={words} />

          {/* notes */}
          <div className={styles['notes-wrap']}>
            <div className={styles['notes-title']}>{words?.support_repair_process_notes}</div>
            <ul className={styles['notes-list']}>
              <li className={styles['notes-item']}>{words?.support_repair_process_notes_content1}</li>
              <li className={styles['notes-item']}>{words?.support_repair_process_notes_content2}</li>
              <li className={styles['notes-item']}>{words?.support_repair_process_notes_content3}</li>
              <li className={styles['notes-item']}>{words?.support_repair_process_notes_content4}</li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit(ctry: string) {
  return new Promise((resolve, reject) => {
    request.get(`${DOMAIN_API}/o/content/getBannerPages?bannerPositionId=${REPAIRPROCESSPOS}&stationCode=${ctry}`)
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

RepairProcess.getInitialProps = (ctry: string) => {
  return getInit(ctry)
};
export default RepairProcess;
